import { Component, Input, OnInit } from '@angular/core';
import { ITimekitComponent } from '../timekit-tabs/timekit-tabs.component';
import { ApiService } from 'src/app/api.service';
import { ThemingService } from 'src/app/theming.service';
import { Debounce } from 'angular-debounce-throttle';
import { LambdaService } from 'src/app/lambda.service';

interface Client {
  firstName: string;
  lastName: string;
  email?: string;
  remainingSessions?: number;
  scheduledSessions?: number;
}


@Component({
  selector: 'app-timekit-sessions',
  templateUrl: './timekit-sessions.component.html',
  styleUrls: ['./timekit-sessions.component.scss']
})
export class TimekitSessionsComponent implements ITimekitComponent {
  @Input() data: any;
  clients: Client[] = [];
  totalAmount: number = 0;
  order: string = 'DESC';
  loading: boolean = false;
  currentPage: number = 1;
  searchString: string = '';

  constructor(
    private lambdaService: LambdaService,
    private themingService: ThemingService
  ) { }

  ngOnInit(): void {
    this.getClientSessions();
  }

  @Debounce(500)
  serchClients() {
    this.currentPage = 1;
    this.getClientSessions();
  }

  @Debounce(500)
  filterSearch() {
    this.currentPage = 1;
    this.getClientSessions();
  }

  async getClientSessions() {
    this.loading = true;

    try {
      const rawData: any = await this.lambdaService.getClientSessions(this.themingService.shopId);

      let clientsArray = [];

      if (Array.isArray(rawData)) {
        const found = rawData.find((entry: any) => Array.isArray(entry));
        clientsArray = found || [];
      }

      const search = this.searchString.toLowerCase();
      this.clients = clientsArray.filter((client: Client) =>
        (client.firstName + ' ' + client.lastName).toLowerCase().includes(search)
      );

    } catch (error) {
      console.error('Error al obtener clientes:', error);
      this.clients = [];
    }

    this.loading = false;
  }

}
